<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-card class="height-auto">
          <v-card-title>
            Time Tracking
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <Activity></Activity>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BarExample from './BarExample'
  import Activity from './Activity/NowActivity.vue'
  import { Api } from '../../../services';

  import _ from 'lodash';
  export default {
    components: {
      BarExample,
      Activity,
    },
    data() {
      return {
        options: {
          ghostClass: 'ghost',
          sort: false
        },
        dataPoints: null,
        height: 20,
        drag: false,
        draggedId: false,
        hoverId: false,
        myArray: {
          name: 'Report',
          children: [{
            level: 0,
            name: 'afafa',
            children: []
          }, {
            level: 0,
            name: 'afafa2',
            children: []
          }, {
            level: 0,
            name: 'afafa3',
            children: []
          }, {
            level: 0,
            name: 'afafa4',
            children: []
          }, {
            level: 0,
            name: 'afafa5',
            children: []
          }, {
            level: 0,
            name: 'afafa6',
            children: []
          }]
        },

        amount: '',
        project: ''
      }
    },
    mounted() {
      setInterval(() => {
        this.fillData()
      }, 2000)
    },
    methods: {
      hover(e) {
        this.hoverId = e.target.id;
      },
      MoveCallback(e, e2) {
        console.log('eee', e);
      },
      onStart(e) {
        this.drag = true
        console.log('eeee', e);
        this.draggedId = e.item.id;
      },
      onEnd(e) {
        this.drag = false
        let targetIndex = _.findIndex(this.myArray, elem => elem.name === this.hoverId);
        let draggedIndex = _.findIndex(this.myArray, elem => elem.name === this.draggedId);
        if (targetIndex !== -1 && draggedIndex !== -1 && targetIndex !== draggedIndex) {
          //let targetLevel =
          let newElem = _.clone(this.myArray[draggedIndex]);
          newElem.level++;
          this.myArray[targetIndex].children.push(newElem);
          _.remove(this.myArray, elem => elem.name === this.draggedId);
        }
        this.draggedId = false;
        this.hoverId = false;
        console.log('this.myArray', this.myArray);
      },
      recIn(obj, index = 0) {
        return obj.children.length > 0 ? this.recIn(obj.children[0], index = index + 1) : index++;
      },
      moved(e1, e2, e3) {
      },
      increaseHeight() {
        this.height += 10
      },
      getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      fillData() {
        this.dataPoints = {
          labels: ['January' + this.getRandomInt(), 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          datasets: [{
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
          }]
        }
      },
      submit() {
        let params = {
          amount: this.amount,
          project: this.project
        };

        Api.Payments().post(params)
          .then(response => { console.log(response) })
          .catch(e => { console.log(e) });
      }
    },
    computed: {
      myStyles() {
        return {
          height: `${this.height}px`,
          position: 'relative'
        }
      }
    }
  }

</script>

<style>
  h1 {
    font-family: 'Helvetica', Arial;
    color: #464646;
    text-transform: uppercase;
    border-bottom: 1px solid #f1f1f1;
    padding-bottom: 15px;
    font-size: 28px;
    margin-top: 0;
  }

  .Chart {
    padding: 20px;
    box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, .4);
    border-radius: 20px;
    margin: 50px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/Dashboard.vue